<script>
  import {
    REQUEST_REPORT_LOST_CONNECTIONS,
    REQUEST_REPORT_ALL_NOTIFICATIONS,
    REQUEST_REPORT_SENT_SMS,
    GET_SUGGESTION_SCHOOLS,
    GET_SUGGESTION_MUNICIPALITIES,
    REQUEST_REPORT_ISSUED_CARDS,
    REQUEST_REPORT_BLOCKED_CARDS,
    REQUEST_REPORT_PASSAGES,
    REQUEST_REPORT_STATISTICS,
  } from '@/requests/superadmin'
  import ReportsView from "@/views/common/ReportsView";
  import {REPORT_TYPES} from "@/views/common/ReportsView";
  import API from "@/config/api";

  export default {
    extends: ReportsView,
    name: 'SuperadminReportsView',
    data() {
      return {
        reportTypes: [
          {
            request: REQUEST_REPORT_LOST_CONNECTIONS,
            name: 'Сбои в работе школ',
            type: [REPORT_TYPES.withDates],
          },
          {
            request: REQUEST_REPORT_SENT_SMS,
            name: 'Отправленные СМС',
            type: [REPORT_TYPES.withDates],
          },
          {
            request: REQUEST_REPORT_ALL_NOTIFICATIONS,
            name: 'Отправленные уведомления',
            type: [REPORT_TYPES.withDates],
          },
          {
            request: REQUEST_REPORT_ISSUED_CARDS,
            name: 'Выданные карты',
            type: [REPORT_TYPES.withParentUnit, REPORT_TYPES.withCardTypes, REPORT_TYPES.withCardStatuses],
          },
          {
            request: REQUEST_REPORT_BLOCKED_CARDS,
            name: 'Заблокированные карты',
            type: [REPORT_TYPES.withParentUnit],
          },
          {
            request: REQUEST_REPORT_PASSAGES,
            name: 'Проходы',
            type: [REPORT_TYPES.withDates, REPORT_TYPES.withParentUnit, REPORT_TYPES.withCardEventSuccessPassages],
          },
          {
            request: REQUEST_REPORT_STATISTICS,
            name: 'Общая статистика',
            type: [REPORT_TYPES.withParentUnit],
          }
        ],
        suggestionsUnit: GET_SUGGESTION_SCHOOLS,
        suggestionsParentUnit: GET_SUGGESTION_MUNICIPALITIES,
        downloadReport: API.superadmin.reports.download
      }
    },
  }
</script>